import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { FileFieldStore } from 'libs/forms/fieldStores';
import { Field } from 'libs/forms/views/field';
import InputFile from 'components/InputFile';

import {
  Wrapper,
  PreviewWrapper,
  FileCard,
  Size,
} from 'libs/forms/views/fieldTypes/file.styles';

@observer
export class FileField extends Field {
  static defaultStore = FileFieldStore;
  handleFileDrop = accepted => {
    const { fieldStore } = this.props;
    fieldStore.Drop(
      accepted,
      [],
      !['avatar', 'image'].includes(fieldStore.fieldName),
    );
  };

  handleRemoveFile = () => {
    const { fieldStore } = this.props;
    fieldStore.RemoveFile();
  };

  // FIXME - component without a displayname
  // eslint-disable-next-line
  renderDroppedContent = () => {
    const { previewComponent, fieldStore } = this.props;
    if (!fieldStore.value) return null;

    const Preview = previewComponent;
    const fileAppManager = { fieldStore };
    const file = { fileAppManager };

    if (Preview) {
      return (
        <PreviewWrapper>
          <Preview fieldStore={fieldStore} removeFile={this.handleRemoveFile} />
        </PreviewWrapper>
      );
    }
    return (
      <FileCard key={file.filename}>
        {file.filename} <Size>({file.sizeStr})</Size>
      </FileCard>
    );
  };

  render() {
    const { fieldStore, editComponent } = this.props;
    const { prompt, Dragging, StopDragging } = fieldStore;
    const Tag = editComponent || Wrapper;

    return (
      <Tag>
        <InputFile
          accept={fieldStore.conf.accept || ''}
          iconName='upload'
          message={prompt}
          removeBorder={this.props.removeBorder}
          removeOpacity={this.props.removeBorder}
          setOnDragEnter={() => Dragging()}
          setOnDragLeave={() => StopDragging()}
          setOnChange={this.handleFileDrop}
          imgNode={this.renderDroppedContent()}
        />
      </Tag>
    );
  }
}

FileField.propTypes = {
  fieldStore: PropTypes.object,
  fieldName: PropTypes.string,
  editComponent: PropTypes.object,
  previewComponent: PropTypes.func,
  removeBorder: PropTypes.bool,
};
